"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import Button from "./Button";

type SectionTitleProps = {
  title: string;
  highlightRed?: boolean;
  subtitle?: string;
  description?: string;
  align?: "left" | "center" | "right";
  buttonLabel?: string;
  buttonLink?: string;
  imageSrc?: string; // ✅ new prop
  imageAlt?: string;
};

const PrimaryPromotionBanner: React.FC<SectionTitleProps> = ({
  title,
  highlightRed = false,
  subtitle,
  description,
  align = "left",
  buttonLabel,
  buttonLink,
  imageSrc,
  imageAlt = "Promotion Image",
}) => {
  const alignment = {
    left: "text-left items-start",
    center: "text-center items-center",
    right: "text-right items-end",
  };

  const pathname = usePathname();
  const isAboutUs = pathname === "/about-us";

  return (
    <section
      className={`relative custom-container ${isAboutUs ? "" : "md:-mt-24 mt-8"
        } sm:mb-0 mb-6 overflow-hidden`}
    >
      <div
        className={`flex flex-col lg:flex-row bg-white/10 backdrop-blur-sm border border-[#1D214B]/10 rounded-3xl gap-8 px-4 py-8 sm:py-12 `}
      >
        {/* Left Side - Image */}
        {imageSrc && (
          <div className="flex justify-center items-center lg:w-1/4">
            <Image
              src={imageSrc}
              alt={imageAlt}
              width={500}
              height={400}
              className="w-auto h-16  object-contain px-2"
            />
          </div>
        )}

        {/* Right Side - Text */}
        <div
          className={`flex flex-col gap-6 justify-center lg:w-3/4 ${alignment[align]}`}
        >
          <div className="w-full ">
            {subtitle && (
              <h4 className="text-sm xs:text-base sm:text-lg text-center md:text-xl lg:text-2xl font-semibold tracking-tight mb-2 text-[#1b1b1b]">
                {subtitle}
              </h4>
            )}

            <h1
              className={`font-semibold tracking-tight ${highlightRed ? "text-[#cd]" : "text-[#272d57]"
                } text-lg sm:text-2xl md:text-3xl text-center xl:text-left lg:text-4xl 3xl:text-5xl`}
            >
              {title}
            </h1>

            {description && (
              <p className="py-2 sm:py-3 3xl:py-4 text-sm sm:text-base 2xl:text-lg 3xl:text-xl text-[#1b1b1b]">
                {description}
              </p>
            )}

            {buttonLabel && (
              <Link href={buttonLink || "#"}>
                <Button
                  responsiveSize={{
                    mobile: "md",
                    tablet: "md",
                    desktop: "lg",
                  }}
                  className="mt-3"
                >
                  {buttonLabel}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrimaryPromotionBanner;
